import { Track } from '../../../classes/track'
import { TrackFields } from '../../../constants'

export function findTracksWithEncodedCharacters(tracks: Track[]) {
  return tracks.filter(t => /&\w+;/i.test(t.title))
}

function decodeHtmlCharCodes(str: string): string {
  return str.replace(/(&#?(.{1,6});)/ig, function (match, capture: string) {
    const parser = new DOMParser()

    const dom = parser.parseFromString('<!doctype html><body>' + capture.toLowerCase(), 'text/html')

    return dom.body.textContent || ''
  })
}

export function replaceEncodedCharacters(track: any, values: any[]): string | null {
  const field: TrackFields = values[0]

  const s: string = track[field]

  // TODO: test in ava
  if (s) {
    return decodeHtmlCharCodes(s)
  } else {
    return null
  }
}
